import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@material-ui/core';
import useStyles from './Tag.styled';

const Tag = ({ item }) => {
  const classes = useStyles();

  useEffect(() => {}, []);

  return (
    <Box className={classes.tagItem}>
      <Typography variant="h4">
        <Box fontSize={11} className={classes.textSecondary}>
          {item}
        </Box>
      </Typography>
    </Box>
  );
};

Tag.propTypes = {
  item: PropTypes.any.isRequired,
};

export default Tag;
